<template>
	<div>
		<sBox title="Grade de gestores">
			<div slot="tools">
				<aBtn
					action="private-save-managers"
					@click="$refs.modal.open()"
					text="Gestores"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<br />
				<div class="row">
					<div class="pull-right col-sm-4">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
							<input
								type="text"
								@input="filter($event.target.value)"
								placeholder="Pesquisar"
								class="form-control"
							/>
						</div>
					</div>
				</div>
				<br />
				<sTable
					ref="tab"
					actionRead="private-read-managers"
					actionDelete="private-delete-managers"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					:tags="tags"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, aBtn, modal },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'razao_social', label: 'Razão social' },
					{ data: 'cnpj', label: 'CNPJ' },
					{ data: 'tipo', label: 'Tipo' },
				],
				tags: [
					{
						cod: 'tipo',
						value: 'sede',
						html: 'SEDE',
						color: 'primary',
					},
					{
						cod: 'tipo',
						value: 'filial',
						html: 'FILIAL',
						color: 'info',
					},
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
				],
			};
		},
		methods: {
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(`
							cod = '${data}' or 
							razao_social like '%${data}%' or 
							cnpj like '${data}' or 
							tipo like '%${data}%'
					`);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gestores', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/managers/index.vue